module.exports = __webpack_public_path__ + "static/img/4254b51184dc3e646fe5528bd7991984.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ck_box.png
// module id = PIVb
// module chunks = 1